import { CanDeactivateFn } from '@angular/router';

// A route component that can hold unsaved design work - the builders themselves, or a host-app
// wrapper (cb-ui's design-3d-redesign page) that delegates to the builder it renders.
export interface UnsavedDesignHost {
  // Resolves true when the navigation may go on. Asks the user first when there are unsaved changes.
  confirmLeave(): boolean | Promise<boolean>;
}

// In-app navigation only. Tab close/reload/full-page navigation never reach the router, and get no
// browser beforeunload prompt by design - the builders' local draft restore covers those instead.
export const unsavedDesignGuard: CanDeactivateFn<UnsavedDesignHost> = (component) => {
  if (!component?.confirmLeave) {
    return true;
  }
  return component.confirmLeave();
};
